import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['panel'];

  toggle() {
    this.panelTarget.hidden = !this.panelTarget.hidden;
  }
}
